export class MenuStage {
    CalculationWeight: number;
    CalorificValue: number;
    CalorificValuePerDay: number;
    CalorificValuePerDayDiff: number;
    CalorificValuePerDayPlan: number;
    Carbohydrates: number;
    CarbohydratesPerDay: number;
    CarbohydratesPerDayDiff: number;
    CarbohydratesPerDayPlan: number;
    Fats: number;
    FatsPerDay: number;
    FatsPerDayDiff: number;
    FatsPerDayPlan: number;
    Id_Plan: number;
    Id_Profile: number;
    Id_Recipe: number;
    Id_Stage: number;
    N_DayName: string;
    N_Part: number;
    N_PartName: string;
    N_day: number;
    PlansName: string;
    ProfileName: string;
    Proteins: number;
    ProteinsPerDay: number;
    ProteinsPerDayDiff: number;
    ProteinsPerDayPlan: number;
    RecipeChanged: number;
    RecipeImage: string;
    RecipeImagePath: string;
    RecipeName: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/menu-stage-model.ts